import RelationsEditable from 'components/RelationsEditable';
import useEntities from 'hooks/useEntities';
import useLoginStore from 'store/loginStore';

const UserOrganizations = ({ sourceEntityId, data, onChange }) => {
    const entities = useEntities();
    const isSystemAdmin = useLoginStore(s => s.isSystemAdmin)();
    const sourceEntity = entities.User;
    const targetEntity = entities.Organization;

    return (
        <RelationsEditable 
            data={data}
            sourceEntity={sourceEntity} 
            targetEntity={targetEntity}
            sourceEntityId={sourceEntityId}
            emptyMessage={`This ${sourceEntity.displayName} does not belong to any ${targetEntity.displayNamePlural}`}
            onChange={onChange}
            canRemove={isSystemAdmin || data?.length > 1} //opeq
        />
    )
}

export default UserOrganizations
